import Layout from "../shared/components/Layout";
import MasterCard from "../assets/img/Mastercard.png";
import Visa from "../assets/img/Infinite_Card.png";
import { useNavigate } from "react-router-dom";

const CardCustom = () => {
  const customer = JSON.parse(sessionStorage.getItem("customer"));

  const navigate = useNavigate();

  const initFlow = () => {
    navigate("/");
    sessionStorage.removeItem('customer')
  };
  

  return (
    <Layout>
      <section className="content-form me">
        <h1> Hola {customer.nombre}</h1>
        <p>
          porque sabemos lo que te gusta te recomendamos estas tarjetas para ti:
        </p>
        <article className="cards-me">
        <div className="type-card text-center">
          <div className="img-tarjeta text-center cs-imagen">
            <img
              className="cs-imagen-efecto"
              src={Visa}
              alt="Visa"
            />
          </div>
          <h2 className="title-card">Visa Infinite</h2>
          <p>
          Acceso a salas VIP en los principales aeropuertos del mundo con Priority Pass.
          </p>
          <p>
            <strong className="exc-int">¡Exclusivo por internet!</strong>
          </p>
          <br />
          <button type="button" className="bc-button-primary submit-btn" onClick={() => initFlow()}>
            Solicitar ahora
          </button>
        </div>
        <div className="type-card text-center">
          <div className="img-tarjeta text-center cs-imagen">
            <img
              className="cs-imagen-efecto"
              src={MasterCard}
              alt="MasterCard"
            />
          </div>
          <h2 className="title-card">Mastercard Black</h2>
          <p>
            Viaja sin parar y descansa en la comodidad de las salas VIP
            nacionales e internacionales.
          </p>
          <p>
            <strong className="exc-int">¡Exclusivo por internet!</strong>
          </p>
          <br />
          <button type="button" className="bc-button-primary submit-btn" onClick={() => initFlow()}>
            Solicitar ahora
          </button>
        </div>
        </article>
      </section>
    </Layout>
  );
};

export default CardCustom;
